// @flow
import produce from 'immer';

import type { Action } from 'Lib/reduxType';
import uuid from 'Lib/utils/uuid';

import { getCommonResetAction } from 'Store/commonActions';

import { RECS_END, RECS_RATE, RECS_SESSION, RECS_START } from './recs/events';
import { TRACK_SPARKS_EVENT } from './constants';
import { APP_OPEN, APP_REC_REQ_DONE, APP_REC_REQ_SENT, AUTH_START } from './sparks.events';
import type { SparksState } from './types';

export const initialState: SparksState = {
  appOpenTime: new Date(),
  authFrom: 1,
  authId: uuid(),
  hasPreviouslyLoggedIn: false,
  loginStartTime: null,
  mediaSessionId: null,
  recsReqEndTime: null,
  recsReqStartTime: null,
  recsSwipeLength: 0,
  recsSwipingEndTime: null,
  recsSwipingStartTime: null,
  recsSessionId: null,
};

// Manages internal state for analytics events
export const reducer = produce<SparksState, Action>((draft: SparksState, action: Action) => {
  // Sparks state should only ever update on TRACK_SPARKS_EVENT
  if (action.type === TRACK_SPARKS_EVENT) {
    const { eventType, eventData = {} } = action.payload;

    switch (eventType) {
      case APP_OPEN:
        draft.appOpenTime = new Date();
        break;

      case APP_REC_REQ_SENT:
        draft.recsReqStartTime = new Date();
        break;

      case APP_REC_REQ_DONE:
        draft.recsReqEndTime = new Date();
        break;

      case AUTH_START:
        draft.authFrom = eventData.authFrom;
        draft.hasPreviouslyLoggedIn = eventData.hasPreviouslyLoggedIn;
        break;

      case RECS_START:
        draft.recsSwipingStartTime = new Date();
        draft.recsSwipeLength = 0;
        break;

      case RECS_RATE:
        draft.recsSwipeLength += 1;
        break;

      case RECS_END:
        draft.recsSwipingEndTime = new Date();
        break;
      case RECS_SESSION:
        draft.recsSessionId = eventData.type === 'start' ? uuid() : null;
        break;

      default:
        return draft;
    }
  }

  if (getCommonResetAction(action.type)) {
    return {
      ...initialState,
      authId: uuid(),
    };
  }

  return draft;
}, initialState);
